export default "__VITE_ASSET__DcbvVnsY__"